export default __webpack_public_path__ + "static/media/malouppas-papakostas-group.a4f1e52d.jpg";